import React from 'react';
import { arrayMove } from 'react-sortable-hoc';
import { getSecondary } from '../../styles/colors';

import { AlertConfirm, SortableList } from '../../UI';


const ReorderPointsModal = ({
	updateAndSave,
	translate,
	style,
	items,
	label,
}) => {
	const [state, setState] = React.useState(items);
	const [reorderModal, setReorderModal] = React.useState(false);


	React.useEffect(() => {
		setState(items);
	}, [items]);


	const updateOrder = () => {
		setReorderModal(false);
		updateAndSave(state);
	};

	const reset = () => {
		setReorderModal(false);
		setState(items);
	};

	const onSortEnd = ({ oldIndex, newIndex }) => {
		setState(arrayMove(state, oldIndex, newIndex));
	};

	const generateKey = React.useMemo(() => Math.random().toString(36).substr(2, 9), [items]);


	const renderNewPointBody = () => {
		const opened = state.map(({ text, label: itemLabel, name }, index) => (
			<li
				key={`items_list_${generateKey + index}`}
				className="draggable"
			>
				{text[translate.currentLanguage] || translate[itemLabel] || name}
			</li>
		));

		return (
			<React.Fragment>
				<SortableList
					items={opened}
					offset={opened.lenght}
					onSortEnd={onSortEnd}
					helperClass="draggable"
				/>
			</React.Fragment>
		);
	};

	return (
		<React.Fragment>
			<button
				onClick={() => setReorderModal(true)}
				style={{
					border: `1px solid ${getSecondary()}`,
					borderRadius: '4px',
					padding: '.5rem',
					background: 'transparent',
					cursor: 'pointer',
					color: getSecondary(),
					...style
				}}
			>
				{label}
			</button>
			<AlertConfirm
				requestClose={reset}
				open={reorderModal}
				acceptAction={updateOrder}
				buttonAccept={translate.save}
				scrollable={true}
				buttonCancel={translate.cancel}
				bodyText={renderNewPointBody()}
				title={'Reorganizar campos'}
			/>
		</React.Fragment>
	);
};

export default ReorderPointsModal;

